// routes/basicRoutes.js
import { lazy } from 'react';
import MainLayout from '../layouts/mainLayout'; // Import MainLayout


// Lazy load basic pages
const AboutPage = lazy(() => import('../pages/basic/About'));
const ContactPage = lazy(() => import('../pages/basic/Contact'));
const HomePage = lazy(() => import('../pages/basic/Home'));
// const MainLayout = lazy(() => import('../layouts/mainLayout'))

// import Industries Pages
// const AgriAndFarming = lazy(() => import('../pages/basic/industries/agricultureandfarming'));
// const AiDrivenBusinesses = lazy(() => import('../pages/basic/industries/aidrivenbusinesses'));
// const Healthcare = lazy(() => import('../pages/basic/industries/healthcare'));
// const LogisticsAndSupply = lazy(() => import('../pages/basic/industries/logisticsandsupply'));
// const RetailAndECommerce = lazy(() => import('../pages/basic/industries/retailandecommerce'));
// const SmartCities = lazy(() => import('../pages/basic/industries/smartcities'));

// import Industries Pages
const Healthcare = lazy(() => import('../pages/basic/industries/healthcare'));
const EnvironmentalAndInfraSensing = lazy(() => import('../pages/basic/industries/environment-and-infra-sensing'));
const QuantumAIEdgeIotDevices = lazy(() => import('../pages/basic/industries/quantum-ai-edge-iot-devices'));
const DefenseAndAntiJammingSystems = lazy(() => import('../pages/basic/industries/defense-and-anti-jamming-systems'));
const DataSecurity = lazy(() => import('../pages/basic/industries/data-security'));
const AdvancedDroneTechnology = lazy(() => import('../pages/basic/industries/advanced-drone-technology'));

// import solutions pages
// const SolCuttingEdgeTechnology  = lazy(() => import('../pages/basic/solutions/cuttingedgetechnology'));
// const SolAdvanceGPSTracking  = lazy(() => import('../pages/basic/solutions/advancegpstracking'));
// const SolAIDriven  = lazy(() => import('../pages/basic/solutions/solutionaidriven'));
// const SolSeamlessApiIntegration  = lazy(() => import('../pages/basic/solutions/seamlessapiintegration'));
// const GenAIAndAutomation  = lazy(() => import('../pages/basic/solutions/genaiandautomation'));
 
// import Innovations Pages
const EdgeDeployableQuantumSensingPlatform = lazy(() => import('../pages/basic/innovations/edg-depl-quantum-sens-platform'));
const SelfAdaptiveQuantumSystems = lazy(() => import('../pages/basic/innovations/self-adaptive-quantum-systems'));
const QuantumAIDesignPlatform = lazy(() => import('../pages/basic/innovations/quantum-ai-design-platform'));
const QuantumSecurity = lazy(() => import('../pages/basic/innovations/quantum-security'));


// Import active solution pages
const SolDesignSimulationQuantumDots = lazy(() => import('../pages/basic/solutions/design-simulation-quantum-dots'));
const SolAIMiddlewareForTuning = lazy(() => import('../pages/basic/solutions/ai-middleware-for-tuning'));
const SolAutomatedCalibrationControl = lazy(() => import('../pages/basic/solutions/automated-calibration-control'));
const SolQuantumSkinForIntelligentInfra = lazy(() => import('../pages/basic/solutions/quantum-skin-for-intelligent-infra'));


const OurCareerPage = lazy(() => import('../pages/basic/opportunity/ourcareerpage'))


const AboutOurStoryPage = lazy(() => import('../pages/basic/about/aboutourstorypage'))
const AboutTeamPage = lazy(() => import('../pages/basic/about/aboutteam'))
const AboutLeadershipPage = lazy(() => import('../pages/basic/about/aboutleadership'))
const AboutCompanyStoryPage = lazy(() => import('../pages/basic/about/aboutcompanystorypage'))
const AboutPartnerPage = lazy(() => import('../pages/basic/about/aboutpartnerpage'))
const AboutBlogPage = lazy(() => import('../pages/basic/about/aboutblogpage'))



const Documentation = lazy(() => import('../pages/basic/supportandpolicies/documentation'))
const APIStatus = lazy(() => import('../pages/basic/supportandpolicies/apistatus'))
const CustomerSupport = lazy(() => import('../pages/basic/supportandpolicies/customersupport'))
const Integrations = lazy(() => import('../pages/basic/supportandpolicies/integrations'))
const LegalSupport = lazy(() => import('../pages/basic/supportandpolicies/legalsupport'))
const PrivacyPolicy = lazy(() => import('../pages/basic/supportandpolicies/privacypolicy'))
const ReportAnIssue = lazy(() => import('../pages/basic/supportandpolicies/reportanissue'))
const TermsAndConditions = lazy(() => import('../pages/basic/supportandpolicies/termsandconditions'))



const AiDrivenInnovationBlog = lazy(() => import('../pages/basic/blogs/aidriveninnovationblog'))
const HowGpsTransformingLogistics = lazy(() => import('../pages/basic/blogs/howgpstechtransforminglogistics'))
const ProductReliabilityMatters = lazy(() => import('../pages/basic/blogs/productreliabilitymatters'))
const ScalingBusinessWithAI = lazy(() => import('../pages/basic/blogs/scalingbusinesswithai'))






export const basicRoutes = [
  // { path: '/about', element: <AboutPage /> },
  // { path: '/contact', element: <ContactPage /> },

    // route to landing page
    { path: '/', 
      element: (
        <MainLayout>
          <HomePage />
        </MainLayout>
      ), 
    },
  // route to landing page
  { path: '/home', 
    element: (
      <MainLayout>
        <HomePage />
      </MainLayout>
    ), 
  },

  // Route to the Industries company works under different sectors  
  // Route to Industries GenXZAI works in
{
  path: '/industries/healthcare',
  element: (
    <MainLayout>
      <Healthcare />
    </MainLayout>
  ),
},
{
  path: '/industries/environment-and-infra-sensing',
  element: (
    <MainLayout>
      <EnvironmentalAndInfraSensing />
    </MainLayout>
  ),
},
{
  path: '/industries/quantum-ai-edge-iot-devices',
  element: (
    <MainLayout>
      <QuantumAIEdgeIotDevices />
    </MainLayout>
  ),
},
{
  path: '/industries/defense-and-anti-jamming-systems',
  element: (
    <MainLayout>
      <DefenseAndAntiJammingSystems />
    </MainLayout>
  ),
},
{
  path: '/industries/data-security',
  element: (
    <MainLayout>
      <DataSecurity />
    </MainLayout>
  ),
},
{
  path: '/industries/advanced-drone-technology',
  element: (
    <MainLayout>
      <AdvancedDroneTechnology />
    </MainLayout>
  ),
},


  // { path: '/industries/healthcare', 
  //   element: (
  //     <MainLayout>
  //       <Healthcare />
  //     </MainLayout>
  //   ),  
  // },
  // { path: '/industries/logistic-and-supply', 
  //   element: (
  //     <MainLayout>
  //       <LogisticsAndSupply />
  //     </MainLayout>
  //   ), 
  // },

  // { path: '/industries/retail-and-ecommerce', 
  //   element: (
  //     <MainLayout>
  //       <RetailAndECommerce />
  //     </MainLayout>
  //   ), 
  // },
  // { path: '/industries/agriculture-and-farming', 
  //   element: (
  //     <MainLayout>
  //       <AgriAndFarming />
  //     </MainLayout>
  //   ),  
  // },
  // { path: '/industries/smartcities', 
  //   element: (
  //     <MainLayout>
  //       <SmartCities />
  //     </MainLayout>
  //   ), 
  // },
  // { path: '/industries/ai-driven-businesses', 
  //   element: (
  //     <MainLayout>
  //       <AiDrivenBusinesses />
  //     </MainLayout>
  //   ), 
  // },

  // Route to Solutions provided by company
  { path: '/solutions/design-simulation-quantum-dots', 
    element: (
      <MainLayout>
        <SolDesignSimulationQuantumDots />
      </MainLayout>
    ),  
  },
  { path: '/solutions/ai-middleware-for-tuning', 
    element: (
      <MainLayout>
        <SolAIMiddlewareForTuning />
      </MainLayout>
    ),  
  },
  { path: '/solutions/automated-calibration-control', 
    element: (
      <MainLayout>
        <SolAutomatedCalibrationControl />
      </MainLayout>
    ),  
  },
  { path: '/solutions/quantum-skin-for-intelligent-infra', 
    element: (
      <MainLayout>
        <SolQuantumSkinForIntelligentInfra />
      </MainLayout>
    ),  
  },
  

  // Route to Innovations by GenXZAI
{
  path: '/innovations/edge-deployable-quantum-sensing-platform',
  element: (
    <MainLayout>
      <EdgeDeployableQuantumSensingPlatform />
    </MainLayout>
  ),
},
{
  path: '/innovations/self-adaptive-quantum-systems',
  element: (
    <MainLayout>
      <SelfAdaptiveQuantumSystems />
    </MainLayout>
  ),
},
{
  path: '/innovations/quantum-ai-design-platform',
  element: (
    <MainLayout>
      <QuantumAIDesignPlatform />
    </MainLayout>
  ),
},
{
  path: '/innovations/quantum-security',
  element: (
    <MainLayout>
      <QuantumSecurity />
    </MainLayout>
  ),
},


  // Route to Solutions provided by company
  // { path: '/solutions/cutting-edge-technology', 
  //   element: (
  //     <MainLayout>
  //       <SolCuttingEdgeTechnology />
  //     </MainLayout>
  //   ),  
  // },

  // { path: '/solutions/seamless-api-integration', 
  //   element: (
  //     <MainLayout>
  //       <SolSeamlessApiIntegration />
  //     </MainLayout>
  //   ), 
  // },

  // { path: '/solutions/advance-gps-tracking', 
  //   element: (
  //     <MainLayout>
  //       <SolAdvanceGPSTracking />
  //     </MainLayout>
  //   ), 
  //  },

  // { path: '/solutions/ai-driven', 
  //   element: (
  //     <MainLayout>
  //       <SolAIDriven />
  //     </MainLayout>
  //   ), 
  //  },

  // { path: '/solutions/genai-and-automation', 
  //   element: (
  //     <MainLayout>
  //       <GenAIAndAutomation />
  //     </MainLayout>
  //   ), 
  //  },

  // { path: '/solutions/usecases', 
  //   element: (
  //     <MainLayout>
  //       <HomePage />
  //     </MainLayout>
  //   ), 
  //  },


  // Route to Careers who want to join our mission and vision...  
  { path: '/careers', 
    element: (
      <MainLayout>
        <OurCareerPage />
      </MainLayout>
    ), 
   },

  // Route to Knowledge Hub of the company and rules, blogs etc
  // { path: '/knowledgehub/blogs', 
  //   element: (
  //     <MainLayout>
  //       <HomePage />
  //     </MainLayout>
  //   ), 
  //  },

  // { path: '/knowledgehub/blogs/ai-driven-innovations', 
  //   element: (
  //     <MainLayout>
  //       <HomePage />
  //     </MainLayout>
  //   ), 
  //  },

  // { path: '/knowledgehub/blogs/how-gps-technology-transforming-logistic', 
  //   element: (
  //     <MainLayout>
  //       <HomePage />
  //     </MainLayout>
  //   ), 
  //  },

  // { path: '/knowledgehub/blogs/scaling-business-with-ai', 
  //   element: (
  //     <MainLayout>
  //       <HomePage />
  //     </MainLayout>
  //   ), 
  //  },

  // { path: '/knowledgehub/blogs/why-product-reliability-matters', 
  //   element: (
  //     <MainLayout>
  //       <HomePage />
  //     </MainLayout>
  //   ), 
  //  },

  // { path: '/knowledgehub/guide-and-tutorials', 
  //   element: (
  //     <MainLayout>
  //       <HomePage />
  //     </MainLayout>
  //   ), 
  //  },

  // { path: '/knowledgehub/case-studies', 
  //   element: (
  //     <MainLayout>
  //       <HomePage />
  //     </MainLayout>
  //   ), 
  //  },

  // { path: '/knowledgehub/faqs', 
  //   element: (
  //     <MainLayout>
  //       <HomePage />
  //     </MainLayout>
  //   ), 
  //  },

  // { path: '/knowledgehub/product-documentation', 
  //   element: (
  //     <MainLayout>
  //       <HomePage />
  //     </MainLayout>
  //   ), 
  //  },

  // { path: '/knowledgehub/industry-reports', 
  //   element: (
  //     <MainLayout>
  //       <HomePage />
  //     </MainLayout>
  //   ), 
  //  },

  // { path: '/knowledgehub/data-protection-and-security', 
  //   element: (
  //     <MainLayout>
  //       <HomePage />
  //     </MainLayout>
  //   ), 
  //  },

  // { path: '/knowledgehub/news-and-events', 
  //   element: (
  //     <MainLayout>
  //       <HomePage />
  //     </MainLayout>
  //   ), 
  //  },


  // Route to About Us and detail about our teams and mission


  { path: '/aboutus', 
    element: (
      <MainLayout>
        <AboutPage />
      </MainLayout>
    ), 
   },   // aboutus and aboutus/company-overview same only

  { path: '/aboutus/company-overview', 
    element: (
      <MainLayout>
        <AboutCompanyStoryPage />
      </MainLayout>
    ), 
   },

  { path: '/aboutus/our-story', 
    element: (
      <MainLayout>
        <AboutOurStoryPage />
      </MainLayout>
    ), 
   },

  { path: '/aboutus/our-team', 
    element: (
      <MainLayout>
        <AboutTeamPage />
      </MainLayout>
    ),  },
    

  { path: '/aboutus/leadership', 
    element: (
      <MainLayout>
        <AboutLeadershipPage />
      </MainLayout>
    ),  },

  { path: '/aboutus/partners', 
    element: (
      <MainLayout>
        <AboutPartnerPage />
      </MainLayout>
    ), 
   },


  // route to the press and partners page
  { path: '/aboutus/blogs', 
    element: (
      <MainLayout>
        <AboutBlogPage />
      </MainLayout>
    ), 
   },


   { path: '/blogs/ai-diven-innovation', 
    element: (
      <MainLayout>
        <AiDrivenInnovationBlog />
      </MainLayout>
    ), 
   },


   { path: '/blogs/gps-transforming-logistics', 
    element: (
      <MainLayout>
        <HowGpsTransformingLogistics />
      </MainLayout>
    ), 
   },
   
   { path: '/blogs/product-reliability-matters', 
    element: (
      <MainLayout>
        <ProductReliabilityMatters />
      </MainLayout>
    ), 
   },
   
   { path: '/blogs/scaling-business-with-ai', 
    element: (
      <MainLayout>
        <ScalingBusinessWithAI />
      </MainLayout>
    ), 
   },
  


  
  // route to contact the company
  { path: '/contact', 
    element: (
      <MainLayout>
        <ContactPage />
      </MainLayout>
    ), 
   },

   

  // Route to support given to the company
  // { path: '/support/product-pricing', 
  //   element: (
  //     <MainLayout>
  //       <Suspense fallback={<div>Loading...</div>}>
  //         <ContactPage />
  //       </Suspense>
  //     </MainLayout>
  //   ), 
  //  },

  { path: '/support/documentation', 
    element: (
      <MainLayout>
        <Documentation />
      </MainLayout>
    ), 
   },

  { path: '/support/customer-support', 
    element: (
      <MainLayout>
        <CustomerSupport />
      </MainLayout>
    ), 
   },

  { path: '/support/api-status', 
    element: (
      <MainLayout>
        <APIStatus />
      </MainLayout>
    ), 
   },

  { path: '/support/integrations', 
    element: (
      <MainLayout>
        <Integrations />
      </MainLayout>
    ), 
   },

  
  { path: '/support/report-an-issue', 
    element: (
      <MainLayout>
        <ReportAnIssue />
      </MainLayout>
    ), 
   },

  { path: '/support/privacy-policy', 
    element: (
      <MainLayout>
        <PrivacyPolicy />
      </MainLayout>
    ), 
   },

  { path: '/support/terms-and-conditions', 
    element: (
      <MainLayout>
        <TermsAndConditions />
      </MainLayout>
    ), 
   },

  { path: '/support/legal-support', 
    element: (
      <MainLayout>
        <LegalSupport />
      </MainLayout>
    ), 
   },


   // { path: '/support/industry-reports', 
  //   element: (
  //     <MainLayout>
  //       <HomePage />
  //     </MainLayout>
  //   ), 
  //  },
    
  // { path: '/support/data-protection-and-security', 
  //   element: (
  //     <MainLayout>
  //       <HomePage />
  //     </MainLayout>
  //   ), 
  //  },


  //   // Route with MainLayout (ContactPage wrapped in MainLayout)
  // {
  //   path: '/contact/mainlayout',
  //   element: (
  //       <MainLayout>
  //       <ContactPage />
  //       </MainLayout>
  //   ),
  //   },
];
